import { render, staticRenderFns } from "./RemoteDesktop.vue?vue&type=template&id=bc2e967a"
import script from "./RemoteDesktop.vue?vue&type=script&lang=js"
export * from "./RemoteDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports